import React from "react";
import { t, Trans } from "@lingui/macro";
import { Col, Row, Tag } from "antd";
import {isMobile} from 'react-device-detect';

export function SearchGuide({ visible }) {
    const pagesExample = [
        t`Invoice`, t`New Payment`, t`Batch Contacts`,
        t`Product Groups`, t`Company Settings`,
    ];
    const transactionsExample = [
        {
            group: t`Sales`,
            children: [
                t`quotation`,
                t`invoice`,
                t`credit note`,
                t`payment`,
                t`refund`,
            ],
        },
        {
            group: t`Purchases`,
            children: [
                t`purchase order`,
                t`bill`,
                t`supplier credit`,
                t`purchase payment`,
                t`purchase refund`,
            ],
        },
        {
            group: t`Others`,
            children: [
                t`money in`,
                t`money out`,
                t`transfer`,
                t`purchase payment`,
                t`journal entry`,
            ],
        },
    ];
    return (
        <div
            className={`searchHintContainer ${!visible ? 'display-none' : ''}`}
        >
            <Row>
                <Col flex="0 0 auto">
                    <Row justify="space-between" style={{alignItems: 'center'}}>
                        <h2><Trans>QUICK SEARCH</Trans></h2>
                        {
                            !isMobile ? (
                                <span className="flex-center" style={{opacity: 0.6}}>
                                    <Trans>
                                        <sup>SHORTCUT</sup>
                                        &nbsp;
                                        <kbd className="kbd-btn">/</kbd>
                                    </Trans>
                                </span>
                            ) : null
                        }
                    </Row>
                    <p>
                        <Trans>Find pages and transaction in an instant.</Trans>
                    </p>
                </Col>
            </Row>

            <br />

            <div className="card-guide pages">
                <h3><Trans>Navigate to Pages</Trans></h3>
                <span><Trans>Try these:</Trans></span>
&nbsp;
                {
                    pagesExample.map(p => (<Tag key={p}>{p}</Tag>))
                }
            </div>
            <br />
            <div className="card-guide transactions">
                <h3><Trans>Find Transactions</Trans></h3>
                <ul style={{ listStyleType: 'disc',
                    listStylePosition: 'inside'}}
                >
                    <li key="transaction">
                        <strong>
                            <Trans>Get a quick overview of your latest transactions. Try these:</Trans>
                        </strong>
                        <ul style={{ paddingBottom: 8 }}>
                            {
                                transactionsExample.map(t => (
                                    <li key={`group_${t.group}`}>
                                        {t.group}
                            &nbsp;
                                        {t.children.map(transaction => (
                                            <Tag key={`groupitem_${transaction}`}>
                                                {transaction}
                                                    &nbsp;
                                            </Tag>
                                        ))}
                                    </li>
                                ))
                            }
                        </ul>
                    </li>

                    <li key="dates">
                        <strong>
                            <Trans>
                                Find transactions on a single date or a date range with two dates:
                            </Trans>
                        </strong>
                        <ul style={{ paddingBottom: 8 }}>
                            <Tag key="dd/mm/yyyy">dd/mm/yyyy</Tag>
                            {' '}
                            <Tag key="dd/mm/yy">dd/mm/yy</Tag>
                            {' '}
                            <Tag key="d/m/y">d/m/yy</Tag>
                        </ul>
                    </li>

                    <li key="keyword">
                        <strong>
                            <Trans>
                                Include any other keywords in your search to match
                            </Trans>
                        </strong>
                        <ul style={{ paddingBottom: 8 }}>
                            <Tag><Trans>Transaction No</Trans></Tag>
                            {' '}
                            <Tag><Trans>Remarks</Trans></Tag>
                            {' '}
                            <Tag><Trans>Contact Name</Trans></Tag>
                        </ul>
                        <ul>
                            <Trans>Examples:</Trans>
                            <li>
                                <Tag>invoice and payment to Alphabet Co on 15/4/19</Tag>
                            </li>
                            <li>
                                <Tag>bill from Wooba Sdn Bhd 01/09/19 - 31/09/19</Tag>
                            </li>
                        </ul>
                    </li>

                </ul>
            </div>

        </div>
    );
}
